import * as React from 'react';
import { Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { styled } from '@mui/material/styles';

const Section = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  borderBottom: '1px solid rgba(233, 234, 238, 1)',
  margin: '0 10px',
  '&.arrowSection': {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(235, 245, 255, 1)',
    },
  },
}));

const Container = styled('div')(() => ({
  padding: '20px 0',
  flexGrow: 2,
  '& label': {
    color: '#565F6F',
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '20px',
  },
}));

const Header = styled(Typography)(() => ({
  color: 'rgba(28, 61, 100, 1)',
  fontFamily: 'Roboto',
  marginBottom: '4px',
  fontSize: '12px',
  '&.disabled': {
    color: '#73777D',
  },
}));

const NavNext = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export interface IProps {
  children: React.ReactNode;
  header: string | React.ReactElement;
  showNavArrow?: boolean;
  disabled?: boolean;
  onClick?(): void;
}

const AccordionSection: React.FC<IProps> = props => {
  return (
    <Section
      className={props.showNavArrow ? 'arrowSection' : ''}
      onClick={() => props.onClick && props.disabled !== true ? props.onClick() : null}
    >
      <Container>
        {props.header !== '' ? (
          <div>
            <Header
              variant='subtitle2'
              className={props.disabled ? 'disabled' : ''}
            >
              {props.header}
            </Header>
          </div>
        ) : null}
        {props.children}
      </Container>
      {props.showNavArrow && props.disabled !== true ? (
        <NavNext>
          <NavigateNextIcon sx={{ color: '#616C79' }} />
        </NavNext>
      ) : null}
    </Section>
  );
};

export default AccordionSection;
